// extracted by mini-css-extract-plugin
export default {"sidecardBodybtn":"style_sidecardBodybtn__Blxlm"};